// src/api/loginApi.js

import axiosInstance from './axiosInstance';
import axios from 'axios';

export const uploadFileApi = async (file, folderName) => {
    try {
      // Step 1: Get the presigned URL and file ID from the backend
      const response = await axiosInstance.post('/file/upload', {
        size: file.size,
        fileType: file.type,
        contentType: file.type,
        displayFileName: file.name,
        fileName: file.name,
        folderName
      });
      const { url, fileId } = response.data;

      await axios.put(url, file, {
        headers: {
          'Content-Type': file.type,
        },
      });

      await axiosInstance.post('/file/update-status-uploaded', { fileId });
  
      return fileId ;
    } catch (error) {
    }
  };
  export const deleteFileApi = async (routePrefix, patientId, fileId) => {
    try {
      const response = await axiosInstance.delete(`${routePrefix}/delete-file/${patientId}/${fileId}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting file:', error);
      throw error;
    }
  };